import React from "react";
import ManageServiceUsersMobileContainer from "../../containers/ManageServiceUsersMobileContainer/ManageServiceUsersMobileContainer";

export default function ManageServiceUsersPageMobile(props: any) {
  return (
      <ManageServiceUsersMobileContainer collapsed={props.collapsed} match={props.match} />
  );
}
